<template>
  
    <el-container>
     
      <el-main>
       <h1>Create rich mode mindmap</h1>
       <h2>Method 1</h2>
       <p>Add yaml to markdown:</p>
       <pre>
        <code>
---

mindmap-plugin: rich

---
        </code>
       </pre>
       <p>Then you can find <i>Open as mindmap</i> menu in more options</p>
       <div>
         <img src="../assets/markmind/rich.gif" alt="" width="800">
       </div>

       <h2>Method 2</h2>
       <p>Change <i>mindmap mode</i>  from  <code>basic</code> to <code>rich</code> in obsidian markmind setting tab</p>
       <p>Right click in folder , click <i>New mindmap board</i> menu</p>
      
       <div>
          <img src="../assets/markmind/richsetup.gif" alt="" width="800">
       </div>
       <div>
           <img src="../assets/markmind/richsetup2.gif" alt="" width="800">
       </div>
       <br>
       <h3>How to export mindmap to image?</h3>
       <p>Use ctrl + p , then click <i>export mindmap to html</i> command , notice: the image in mindmap must be local image , not support image in web</p>
  <br>
  <br>
  <br>
      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'RichModePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
